import { size } from "lodash";
import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// export async function listOrg(page=1,page_size=10) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));
        
//         const response = await fetch(`${API_URL}/organizations/?page=${page}&page_size=${page_size}`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to fetch the Organization list");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }
//         return responseData;

//     }catch(error){
//         console.log("Error while getting org list",error?.data || error.message)
//         throw error;
//     }    
// }

// Helper for sending the org list request
async function attemptListOrg(page = 1, page_size = 10, token,searchTerm) {

    const params = new URLSearchParams({
        page,
        page_size: page_size
    })

    if (searchTerm) params.append('search', searchTerm);

    // const response = await fetch(`${API_URL}/organizations/?page=${page}&page_size=${page_size}`, {
    //     method: 'GET',
    //     headers: {
    //         'Authorization': `Bearer ${token}`,
    //     }
    // });
    const response = await fetch(`${API_URL}/organizations/?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to fetch the Organization list");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function listOrg(page = 1, page_size = 10,searchTerm) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptListOrg(page, page_size, accessToken,searchTerm);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed to be defined
                return await attemptListOrg(page, page_size, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting org list", error?.data || error.message);
        throw error;
    }
}


// create org
// export async function createOrg(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'));

//         const response = await fetch(`${API_URL}/organizations/`,{
//             method:'POST',
//             headers:{
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Failed to create org");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error while creating the Organization", error?.data || error.message)
//         throw error;
//     }
// }

// Helper for sending the create org request
async function attemptCreateOrg(data, token) {
    const response = await fetch(`${API_URL}/organizations/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to create org");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function createOrg(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptCreateOrg(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed to be defined
                return await attemptCreateOrg(data, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while creating the Organization", error?.data || error.message);
        throw error;
    }
}

// update org
// export async function updateOrg(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const orgEditData = {};
//         if(data.name) orgEditData.name = data.name;
//         if(data.address) orgEditData.address = data.address;
//         const response = await fetch(`${API_URL}/organizations/${data.org_id}/`,{
//             method: 'PATCH',
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(orgEditData)
//         })

//         const responseData = await response.json();

//         if(!response.ok){
//             const err = new Error("Editing Org failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error while editing the Org data", error?.data || error.message)
//         throw error;
//     }
// }

// Helper for sending the update org request
async function attemptUpdateOrg(data, token) {
    const orgEditData = {};
    if (data.name) orgEditData.name = data.name;
    if (data.address) orgEditData.address = data.address;

    const response = await fetch(`${API_URL}/organizations/${data.org_id}/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(orgEditData),
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Editing Org failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function updateOrg(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptUpdateOrg(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed to be defined
                return await attemptUpdateOrg(data, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while editing the Org data", error?.data || error.message);
        throw error;
    }
}


// change status
// export async function statusUpdateOrg(data) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/update_org_status/`,{
//             method:"POST",
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             },
//             body: JSON.stringify(data)
//         })

//         const responseData = await response.json()

//         if(!response.ok){
//             const err = new Error("Updating Status failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("Error occurred while updating the status",error?.data ||  error.message)
//         throw error;
//     } 
// }

// Helper function for status update
async function attemptStatusUpdateOrg(data, token) {
    const response = await fetch(`${API_URL}/update_org_status/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Updating Status failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function statusUpdateOrg(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptStatusUpdateOrg(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed defined elsewhere
                return await attemptStatusUpdateOrg(data, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error occurred while updating the status", error?.data || error.message);
        throw error;
    }
}

// delete org
// export async function deleteOrg(orgId) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/organizations/${orgId}/`,{
//             method: 'DELETE',
//             headers:{
//                 "Content-Type": "application/json",
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         let responseData = null;
//         if (response.status !== 204) {
//             responseData = await response.json();
//         }

//         if(!response.ok){
//             const err = new Error("Deleteing Org failed");
//             err.data = responseData;
//             err.status = response.status;
//             throw err;
//         }
//         return responseData;
//     }catch(error){
//         console.log("Error occurred while deleteing the org",error?.data ||  error.message)
//         throw error;
//     }
// }

// Helper function for deletion
async function attemptDeleteOrg(orgId, token) {
    const response = await fetch(`${API_URL}/organizations/${orgId}/`, {
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        }
    });

    let responseData = null;
    if (response.status !== 204) {
        responseData = await response.json();
    }

    if (!response.ok) {
        const err = new Error("Deleting Org failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function deleteOrg(orgId) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
        return await attemptDeleteOrg(orgId, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken(); // assumed defined elsewhere
                return await attemptDeleteOrg(orgId, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error occurred while deleting the org", error?.data || error.message);
        throw error;
    }
}
